import type { RiskFinding } from "../types/riskFinding";
import { getMockFindings } from "../data/mockFindings";
import { updateContractStatus } from "./contractService";
import { clearSessionAndRedirectToLogin, isAuthenticated } from "./authService";
import { apiRequest } from "./apiClient";

function assertAuthenticated(): void {
  if (!isAuthenticated()) {
    clearSessionAndRedirectToLogin();
    throw new Error("Not authenticated");
  }
}

export const getFindings = (contractId: string): Promise<RiskFinding[]> =>
  Promise.resolve().then(() => {
    assertAuthenticated();
    return getMockFindings(contractId);
  });

export const submitForReview = async (
  contractId: string,
  assigneeId?: string | null,
  notes?: string | null
): Promise<void> => {
  assertAuthenticated();
  void assigneeId;
  void notes;
  updateContractStatus(contractId, "Pending Review");
};

export const complete = async (contractId: string): Promise<void> => {
  assertAuthenticated();
  await apiRequest(
    `/generated-contracts/${encodeURIComponent(contractId)}/complete-review`,
    { method: "POST" },
    { requiresAuth: true, redirectOnUnauthorized: true }
  );
  // Keep local list caches (mock fixtures) in sync for any UI still referencing them.
  updateContractStatus(contractId, "Completed");
};
